var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "packages-edit" } },
    [
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c(
            "Row",
            [
              _c("Col", { attrs: { span: "4" } }, [
                _c("div", [
                  _c("span", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("姓名："),
                  ]),
                  _c("span", [_vm._v(_vm._s(_vm.edit.name))]),
                ]),
              ]),
              _c("Col", { attrs: { span: "5" } }, [
                _c("div", [
                  _c("span", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("出生日期："),
                  ]),
                  _c("span", [_vm._v(_vm._s(_vm.edit.birthday))]),
                ]),
              ]),
              _c("Col", { attrs: { span: "5" } }, [
                _c("div", [
                  _c("span", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("条形码："),
                  ]),
                  _c("span", [_vm._v(_vm._s(_vm.edit.barCode))]),
                ]),
              ]),
              _c("Col", { attrs: { span: "4" } }, [
                _c("div", [
                  _c("span", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("收表人："),
                  ]),
                  _c("span", [_vm._v(_vm._s(_vm.edit.operator))]),
                ]),
              ]),
              _c("Col", { attrs: { span: "6" } }, [
                _c("div", [
                  _c("span", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("收表时间："),
                  ]),
                  _c("span", [_vm._v(_vm._s(_vm.edit.createTime))]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._l(_vm.edit.logProjects, function (rowData, index) {
        return _c(
          "el-card",
          {
            staticClass: "box-card",
            staticStyle: { "margin-top": "10px" },
            attrs: { shadow: "never" },
          },
          [
            _c(
              "Row",
              [
                _c(
                  "Col",
                  {
                    staticStyle: {
                      "font-size": "20px",
                      "font-weight": "bold",
                      "margin-bottom": "8px",
                    },
                    attrs: { span: "24" },
                  },
                  [_c("span", [_vm._v(_vm._s(rowData.projectName))])]
                ),
                _vm._l(rowData.logFieldConfigs, function (child) {
                  return _c(
                    "Col",
                    {
                      staticStyle: { "margin-bottom": "5px" },
                      attrs: { span: "6" },
                    },
                    [
                      _c("div", [
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(_vm._s(child.fieldConfigName) + "："),
                        ]),
                        _c("span", [_vm._v(_vm._s(child.fieldConfigValue))]),
                        child.fieldConfigValue && child.unit
                          ? _c(
                              "span",
                              { staticStyle: { "margin-left": "5px" } },
                              [_vm._v(_vm._s(child.unit))]
                            )
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
              ],
              2
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }